import React from "react";
import { Form, Col } from "react-bootstrap";
import Select from "react-select";
import NumberFormat from "react-number-format";

import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import {
  vendorInfoFields,
  vendorPlatformFields,
  removableFields,
  ownedVendorFields,
} from "./FormFields";
import { httpGetAllUsersForPipeLineOwnerRole } from "../../../../service/httpClient";
import { ToolTip } from "../../../Common/Tooltip/ToolTip";
import * as Constants from "../../../../constants/Constants";
import { checkOnBoardingStatus } from "../../../../utils/utils";
import "../../../Common/Tooltip/ToolTip.css";

export const renderFormFields = (
  fields,
  formValues,
  setFormValues,
  simpleValidator,
  isPrimaryVendor,
  isProfileType,
  onboardingStatus
) => {
  return fields.map(
    (
      {
        label,
        name,
        key,
        length,
        disabled,
        fieldType,
        isRequired,
        options,
        cb,
        validation,
        maxLength,
        toolTipId,
        toolTipText,
      },
      index
    ) => {
      let field = "";
      let disableValue = true;

      if (disabled === false) {
        disableValue = disableEditing(formValues);
      }

      if (
        removableFields.includes(key) &&
        formValues.vendorDetails.vendorConnectionPlatform === "directEdiRDS"
      ) {
        return "";
      }

      if (fieldType === "select") {
        field = (
          <>
            <Form.Label
              key={`${key}Label${index}`}
              id={`${name}Label`}
              htmlFor={name}
              style={{ color: "black", fontWeight: "500" }}
            >
              {label}
              {isRequired === "required" && (
                <span className="required"> *</span>
              )}
            </Form.Label>
            {name === "mergeCenter" ? (
              <Select
                name={name}
                options={options}
                isDisabled={disableValue}
                value={formValues.mergeCenterDefaultValue}
                isMulti
                onChange={(value) =>
                  handMergeCenterChange({ name, value }, value, setFormValues)
                }
              />
            ) : (
              <Form.Control
                key={key}
                id={name}
                name={name}
                as="select"
                onChange={(e) =>
                  handleFieldChange(e, formValues, setFormValues)
                }
                onFocus={(e) => simpleValidator.current.showMessageFor(name)}
                onBlur={(e) => simpleValidator.current.showMessageFor(name)}
                disabled={
                  disabled ||
                  (isProfileType === false &&
                  name === "vendorConnectionPlatform"
                    ? true
                    : disableValue) ||
                  (name === "dept" &&
                    (formValues?.hierarchyDetails?.length <= 1 ||
                      !checkOnBoardingStatus(onboardingStatus, [
                        Constants.IN_PROCESS,
                        Constants.ON_HOLD,
                        Constants.OB_COMPLETE,
                      ])))
                }
                value={
                  cb
                    ? formValues.vendorDetails[name] !== null
                      ? cb(formValues.vendorDetails[name])
                      : ""
                    : formValues.vendorDetails[name] !== null
                    ? formValues.vendorDetails[name]
                    : ""
                }
              >
                {options &&
                  options.map(({ label, value }, i) => {
                    return (
                      <>
                        {i === 0 && (
                          <option
                            key={name}
                            value=""
                            disabled={
                              name === "integrationInstructions"
                                ? formValues.onLoadIntegInstrucVal === value
                                : true
                            }
                          >
                            Select...
                          </option>
                        )}
                        <option key={value} value={value}>
                          {label}
                        </option>
                      </>
                    );
                  })}
                {options && options.length > 1 && name === "dept" && (
                  <option key="default" value="default">
                    Default (no primary dvn)
                  </option>
                )}
              </Form.Control>
            )}
            {validation &&
              simpleValidator.current.message(
                name,
                formValues.vendorDetails[name],
                validation
              )}
          </>
        );
      } else if (fieldType === "USDNumber") {
        field = (
          <>
            <Form.Label
              key={`${key}Label`}
              id={`${name}Label`}
              htmlFor={name}
              style={{ color: "black", fontWeight: "500" }}
            >
              {label}
              {isRequired === "required" && (
                <span className="required"> *</span>
              )}
            </Form.Label>
            <NumberFormat
              className="form-control"
              name={name}
              value={
                formValues.vendorDetails[name] !== null
                  ? formValues.vendorDetails[name]
                  : ""
              }
              onValueChange={(value) =>
                setFormValues((state) => ({
                  ...state,
                  valuesChanged: formValues.vendorDetails[name] !== value.value,
                  disableSaveButton: false,
                  formValues: {
                    ...state.formValues,
                    vendorDetails: {
                      ...state.formValues.vendorDetails,
                      [name]: value.value || "",
                    },
                    reset: false,
                  },
                }))
              }
              disabled={disableValue}
              maxLength={maxLength || ""}
              thousandSeparator
              isNumericString
              prefix="$"
              decimalScale={0}
              allowNegative={false}
            />
          </>
        );
      } else {
        field = (
          <>
            {name !== "additionalDVN" && (
              <Form.Label
                key={`${key}Label`}
                id={`${name}Label`}
                htmlFor={name}
                style={{ color: "black", fontWeight: "500" }}
              >
                {label}
                {(name === "tpQualifier" || name === "handlingFeeAmount") &&
                formValues.vendorDetails["vendorConnectionPlatform"] ===
                  "directEdiRDS"
                  ? ""
                  : isRequired === "required" && (
                      <span className="required"> *</span>
                    )}
              </Form.Label>
            )}
            {name === "additionalDVN" && (
              <Form.Label style={{ marginBottom: "0.5rem" }}>
                <ToolTip
                  toolTipId={toolTipId}
                  customStyles="additionalDVNLabel"
                  label={label}
                  toolTipText={formValues.vendorDetails[name]}
                  key={`${key}Label`}
                  id={`${name}Label`}
                  htmlFor={name}
                />
              </Form.Label>
            )}
            <Form.Control
              min={
                name === "goLiveTarget"
                  ? formValues.vendorDetails.splitIntegrationStartDate
                  : ""
              }
              key={key}
              id={name}
              name={name}
              type={fieldType}
              disabled={
                isPrimaryVendor === false &&
                isProfileType === false &&
                name === "vendorCorpName"
                  ? true
                  : disableValue
              }
              maxLength={maxLength || ""}
              onKeyDown={(e) => {
                e.target.name === "goLiveTarget" && e.preventDefault();
              }}
              onChange={(e) => handleFieldChange(e, formValues, setFormValues)}
              onFocus={(e) => simpleValidator.current.showMessageFor(name)}
              onBlur={(e) => simpleValidator.current.showMessageFor(name)}
              value={
                cb
                  ? formValues.vendorDetails[name] !== null
                    ? cb(formValues.vendorDetails[name])
                    : ""
                  : formValues.vendorDetails[name] !== null
                  ? formValues.vendorDetails[name]
                  : ""
              }
            />
            {validation && formValues.reset
              ? simpleValidator.current.hideMessageFor(name)
              : simpleValidator.current.message(
                  name,
                  formValues.vendorDetails[name],
                  validation
                )}
          </>
        );
      }

      return (
        <Form.Group key={key} as={Col} md={length ? length : 3}>
          {field}
        </Form.Group>
      );
    }
  );
};

export const getPiplineUsers = () => {
  let plOwnerOptions = [];
  return httpGetAllUsersForPipeLineOwnerRole()
    .then(({ data }) => {
      const plOwners =
        data &&
        data.map(({ userName, emailId }, index) => {
          plOwnerOptions.push({
            label: userName,
            value: userName,
            emailId,
          });
          return { userName, emailId };
        });

      vendorInfoFields.forEach((obj, index) => {
        if (obj.name === "plOwnerShipName") {
          vendorInfoFields[index].options = plOwnerOptions;
        }
      });

      return plOwners;
    })
    .catch((error) => console.log("Error in Vendor Profile Page: ", error));
};

export const extractformValues = () => {
  let formValues = {};

  [...vendorInfoFields, ...vendorPlatformFields].forEach((obj) => {
    obj.name === "mergeCenter"
      ? (formValues = { ...formValues, [obj.name]: null })
      : (formValues = { ...formValues, [obj.name]: "" });
  });

  return formValues;
};

const handMergeCenterChange = (info, value, setFormValues) => {
  let mergeCenter = null;
  if (info.value && info.value.length > 0) {
    mergeCenter = info.value.map(({ label, value }) => value);
  } else {
    mergeCenter = null;
  }

  return setFormValues((state) => ({
    ...state,
    valuesChanged: true,
    disableSaveButton: false,
    formValues: {
      ...state.formValues,
      mergeCenterDefaultValue: value,
      vendorDetails: {
        ...state.formValues.vendorDetails,
        mergeCenter,
      },
    },
  }));
};

export const extractMergeCenterValues = (mergeCenter) =>
  mergeCenter && mergeCenter.length > 0
    ? mergeCenter.map((value) => ({ value, label: value }))
    : "";

const handleFieldChange = (e, formValues, setFormValues) => {
  e.persist();
  let saveState;
  const dateFields = [
    "macysAgreementDate",
    "chubAgreementDate",
    "nextActionDate",
    "goLiveTarget",
  ];

  if (dateFields.indexOf(e.target.name) !== -1) {
    saveState = {
      [e.target.name]:
        e.target.value === ""
          ? e.target.value
          : changeDateAndAddTime(e.target.value),
    };
  } else if (e.target.name === "vendorConnectionPlatform") {
    let integrationStartDate = formValues.vendorDetails.integrationStartDate
      ? formValues.vendorDetails.integrationStartDate
      : null;

    let ownedVendor = false;
    if (
      formValues.vendorDetails.merchandiseType ===
        Constants.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
      e.target.value === Constants.STATUS_PLATFORMTYPE_DIRECTEDI
    ) {
      ownedVendor = true;
    }

    saveState = {
      goLiveTarget: calculateTargetLiveDate(
        integrationStartDate,
        e.target.value,
        ownedVendor
      ),
      [e.target.name]: e.target.value,
    };
  } else if (e.target.name === "plOwnerShipName") {
    let goLiveTargetPlo = null;
    if (
      formValues.vendorDetails.plOwnerShip == null &&
      formValues.vendorDetails.vendorConnectionPlatform
    ) {
      goLiveTargetPlo = calculateTargetLiveDate(
        new Date(),
        formValues.vendorDetails.vendorConnectionPlatform
      );
    }
    saveState = {
      goLiveTarget: goLiveTargetPlo
        ? goLiveTargetPlo
        : formValues.vendorDetails.goLiveTarget,
      [e.target.name]: e.target.value,
      plOwnerShip: setPlOwnerShipEmail(
        formValues.pipelineUsers,
        e.target.value
      ),
    };
  } else if (e.target.name === "dept") {
    const { value = "", name = "" } = e.target;
    let updateHierarchyDetails = [];

    if (value !== "default") {
      const operDiv = value.substring(0, value.indexOf(" "));
      const deptVendorNumber = value.substring(value.indexOf(" ") + 1);
      const deptNumb = deptVendorNumber.substring(
        0,
        deptVendorNumber.indexOf("/")
      );
      const vendorNumb = deptVendorNumber.substring(
        deptVendorNumber.indexOf("/") + 1
      );

      let operatingDiv = "";

      switch (operDiv) {
        case "M":
          operatingDiv = "MACY'S";
          break;
        case "B":
          operatingDiv = "BLOOMINGDALE'S";
          break;
        case "MBKS":
          operatingDiv = "MACY'S BACKSTAGE";
          break;
        case "BOS":
          operatingDiv = "BLOOMINGDALES OUTLET";
          break;
        default:
          break;
      }

      updateHierarchyDetails = formValues?.hierarchyDetails.map((hierarchy) =>
        hierarchy.operatingDivision === operatingDiv &&
        hierarchy.dept === deptNumb &&
        hierarchy.vendorNumber === vendorNumb
          ? { ...hierarchy, isPrimary: true, isOperDivPrimary: true }
          : { ...hierarchy, isPrimary: false, isOperDivPrimary: false }
      );
    } else {
      updateHierarchyDetails = formValues?.hierarchyDetails.map(
        (hierarchy) => ({
          ...hierarchy,
          isPrimary: false,
          isOperDivPrimary: false,
        })
      );
    }
    setFormValues((state) => ({
      ...state,
      formValues: {
        ...state.formValues,
        hierarchyDetails: updateHierarchyDetails,
      },
    }));
    saveState = { [name]: value };
  } else {
    saveState = { [e.target.name]: e.target.value };
  }

  setFormValues((state) => {
    let formValues = {
      ...state.formValues,
      vendorDetails: {
        ...state.formValues.vendorDetails,
        ...saveState,
      },
      reset: false,
    };
    formValues = resetFormFieldBasedOnVDF(e.target.name, e.target.value, {
      ...state,
      formValues,
    });
    return {
      ...state,
      valuesChanged: true,
      disableSaveButton: false,
      formValues,
      errMsg: "",
    };
  });
};

const resetFormFieldBasedOnVDF = (fieldName, value, state) => {
  const noneRDSFields = [
    "chubAgreementDate",
    "chubIntegrationProfile",
    "chubPackingSlip",
    "altIdDropOnly",
    "vics",
  ];
  const RDSFields = ["testSku", "testPo", "salesCheckNumber", "mergeCenter"];
  let resetValues = { ...state.resetValues.formValues };
  let fullState = { ...state.formValues };
  if (fieldName === "vendorConnectionPlatform") {
    let fieldsArray = value === "directEdiRDS" ? noneRDSFields : RDSFields;
    fieldsArray.forEach((field) => {
      if (field === "mergeCenter") {
        fullState.mergeCenterDefaultValue = resetValues.mergeCenterDefaultValue;
        fullState.vendorDetails[field] = resetValues.vendorDetails[field];
      } else {
        fullState.vendorDetails[field] = resetValues.vendorDetails[field];
      }
    });
  }
  return fullState;
};

export const getSortedArrayBasedOnDept = (hierarchyDetails) => {
  return [
    ...hierarchyDetails.sort((a, b) => {
      let firstDep = parseInt(a?.dept);
      let secDep = parseInt(b?.dept);

      if (firstDep && secDep) {
        return firstDep - secDep;
      }
      return;
    }),
  ];
};

export const extractHierarchyDetails = (data) => {
  let info = {};
  let deptOptions = [];

  if (data && data.length !== 0) {
    const opDivision = new Set();
    data.forEach(({ operatingDivision }) => {
      opDivision.add(operatingDivision);
    });

    data.forEach(({ isPrimary, dept, vendorNumber, operatingDivision }) => {
      let prefix = "";
      if (operatingDivision === "MACY'S") {
        prefix = "M" + " ";
      } else if (operatingDivision === "BLOOMINGDALE'S") {
        prefix = "B" + " ";
      } else if (operatingDivision === "MACY'S BACKSTAGE") {
        prefix = "MBKS" + " ";
      } else if (operatingDivision === "BLOOMINGDALES OUTLET") {
        prefix = "BOS" + " ";
      }

      if (isPrimary) {
        info = {
          dept: prefix + dept + "/" + vendorNumber,
          actualVendorNumber: vendorNumber,
        };
      }

      const label =
        (data.length > 1 && opDivision.size > 1 ? prefix : "") +
        dept +
        (data.length > 1 ? "/" + vendorNumber : "");
      deptOptions.push({
        label,
        value: prefix + dept + "/" + vendorNumber,
      });
    });
  }

  vendorInfoFields.forEach((obj, index) => {
    if (obj.name === "dept") {
      vendorInfoFields[index].options = deptOptions;
    }
  });

  ownedVendorFields.forEach((obj, index) => {
    if (obj.name === "dept") {
      ownedVendorFields[index].options = deptOptions;
    }
  });

  return info;
};

export const changeDateAndAddTime = (date) => {
  const DATE = new Date();
  const time = DATE.toLocaleString("en-US", { hour12: false }).split(", ")[1];
  return `${date}T${time}`;
};

export const getTodaysDateAndTime = () =>
  changeDateAndAddTime(
    new Date()
      .toJSON()
      .slice(0, 10)
      .replace(/-/g, "-")
  );

export const convertTimestampToDate = (date) => {
  if (date == null || date == "") {
    return "";
  }
  let dateToBeConv = new Date(date);
  return (
    (dateToBeConv.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    dateToBeConv
      .getDate()
      .toString()
      .padStart(2, "0") +
    "/" +
    dateToBeConv.getFullYear()
  );
};

export const calculateTargetLiveDate = (
  integrationStartDate,
  vdfPlatform,
  isOwnedVendor = false
) => {
  let finalDate = null;
  if (integrationStartDate) {
    const fourWeeks = 7 * 4;
    const sixWeeks = 7 * 6;
    const eightWeek = 7 * 8;
    const twelveWeeks = 7 * 12;
    // yy-mm-dd
    let numOfWeeks =
      vdfPlatform === "chub"
        ? sixWeeks
        : vdfPlatform === "directEdiRDS"
        ? eightWeek
        : twelveWeeks;

    if (isOwnedVendor) {
      numOfWeeks = fourWeeks;
    }

    const newdate = new Date(integrationStartDate); // should be vdfPlatform

    newdate.setDate(newdate.getDate() + numOfWeeks);

    let dd = newdate.getDate();
    let mm = newdate.getMonth() + 1;
    let yy = newdate.getFullYear();

    dd = dd <= 9 ? "0" + dd : dd;
    mm = mm <= 9 ? "0" + mm : mm;

    finalDate = changeDateAndAddTime(`${yy}-${mm}-${dd}`);
  }

  return finalDate;
};

export const extractDate = (date) => date && date.split("T")[0];

export const setPlOwnerShipEmail = (pipelineUsers, plOwnerShipName) => {
  let plOwnerShip = "";
  pipelineUsers &&
    pipelineUsers.forEach(({ userName, emailId }) => {
      if (plOwnerShipName === userName) {
        plOwnerShip = emailId;
      }
    });

  return plOwnerShip;
};

export const disableIntegrationInstructions = (integInstructions, status) => {
  let integEl = document.getElementById("integrationInstructions");

  if (!integEl) {
    return;
  }

  const integratedInstAPAdminRole =
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_PREBOARDING_VENDORPROFILE,
      RolePermissionConstants.INTEGRATION_INSTRUCTION
    ) === RolePermissionConstants.VIEW;
  if (!!integInstructions || status === false || integratedInstAPAdminRole) {
    integEl.disabled = true;
  } else if (status) {
    integEl.disabled = false;
  }
};

export const disableEditing = (formValues) => {
  let { isMerchApproved, isDVNSetupApproved } = formValues;

  return isMerchApproved &&
    isDVNSetupApproved &&
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_PREBOARDING_VENDORPROFILE,
      RolePermissionConstants.ALL
    ) === RolePermissionConstants.EDIT
    ? false
    : true;
};
